import _typeof from "@babel/runtime/helpers/esm/typeof";
export var getKindProp = function getKindProp(item, defaultValue) {
  return _typeof(item) === 'object' && item.kind ? item.kind : defaultValue;
};